// イントロダクション（About）モーダル。
//
// 役割: 「何ができるサイトか」を簡潔に提示する。初回アクセス時に自動表示し、ヘッダーの
//       About ボタンからいつでも再表示できる。表示済みフラグの保存は App が担う。
// 関係: 既存の .modal-overlay / .modal を流用。App が aboutOpen のとき描画し、onClose で閉じる。
function AboutModal({ onClose }) {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="modal about-modal" onClick={(e) => e.stopPropagation()}>
        <h3>🌐 web-gis-ai-agent</h3>

        <p className="about-lead">
          自然言語で指示すると、AI エージェントが地理空間データ処理を実行し、結果を新しいレイヤーとして
          地図に追加する、ブラウザ完結型の地理空間 AI エージェントです。
          空間処理はブラウザ内で完結し、データはブラウザの外に出ません。
        </p>

        <ul className="about-list">
          <li>🤖 AI に日本語で指示 → バッファ・空間結合・集計・ディゾルブなどを自動実行して新レイヤー化</li>
          <li>📥 データ取込: GeoJSON / FlatGeobuf / GeoParquet / CSV（Shift-JIS 可）</li>
          <li>🧮 データタブ: 位置情報を持たない CSV を取り込み、レイヤーとコードで結合</li>
          <li>🎨 属性値で塗り分け（コロプレス・凡例つき）</li>
          <li>✏️ 地図に作図 ／ 🌐 geoBoundaries行政界取得 ／ 💾 GeoJSON・GeoParquetでエクスポート</li>
        </ul>

        <p className="about-start">
          右の「エージェント」パネルで指示します。AI 対話には Claude APIキーが必要です
          （ヘッダーの「⚙ API設定」から設定）。データ取込・作図・エクスポートはキーなしでも使えます。
        </p>

        <div className="modal-actions">
          <button className="primary" onClick={onClose}>
            はじめる
          </button>
        </div>
      </div>
    </div>
  )
}

export default AboutModal
